import React, { Component } from 'react';
import Popover from '@material-ui/core/Popover';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { injectIntl } from 'react-intl';
import _ from 'lodash';
class Uptime extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openPop: false,
            anchorEl: null,
            idx: undefined,
        }
        this.handlePopoverOpen = this.handlePopoverOpen.bind( this ); 
        this.handlePopoverClose = this.handlePopoverClose.bind( this ); 
        

    }

    componentWillMount() {

    }

    componentDidMount() {

        const {id, percent} = this.props;  
        var margin = {top: 0, right: 0, bottom: 0, left: 0},
        width = 300 - margin.left - margin.right,
        height = 20 - margin.top - margin.bottom;
    
    }

    handlePopoverOpen = (ev) =>{
        const {id, percent} = this.props;

        console.log(ev);
        this.setState({anchorEl: ev.currentTarget, openPop: Boolean(ev.currentTarget), idx: `popover${id}`})
    }
    handlePopoverClose = (ev) =>{
        
        this.setState({anchorEl: null, openPop: false, idx: undefined})
        
    }
    
    render() {
        const {openPop, anchorEl, idx} = this.state;
        const {id, percent, intl, week, month} = this.props;
        return (
            <div data-tip={intl.formatMessage( { id: "UptimeToolTip"}, {day: percent, week, month}  ) }
                id={id} 
                style={{width: 300,
                        height:20,
                        backgroundColor:'#C66445',
                        opacity:0.9,
                        boxShadow:'0 6px 12px rgba(134,140,150,0.65)',
                        position: 'relative',
                }}
            >
              <div  style={{position: 'absolute', width: 300, height:20, width:`${percent}%`,backgroundColor:'#3bd671', opacity:0.9, color: 'white'}} ></div>
              <div style={{position: 'absolute', width: 300, height:20, color: 'white'}}>{percent}%</div>
              <ReactTooltip place="bottom" type="dark" effect="solid"/>
            </div>
        );
    }
}

Uptime.propTypes = {

};

export default injectIntl(Uptime);


// WEBPACK FOOTER //
// ./routes/app/components/Navigation/Uptime/index.js